module.exports = __webpack_public_path__ + "img/bmi.73f10aeb.svg";